export default {"src":"/_next/static/media/wtc.f557cf8e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};